import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-onboarding-check-nor",
  "use": "icon-onboarding-check-nor-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-onboarding-check-nor\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm5.107 6.536a1 1 0 0 0-1.415 0l-4.95 4.95-2.12-2.122a1 1 0 1 0-1.415 1.414l2.829 2.829a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414z\" fill=\"#DADCE1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol